import { useContext } from "react";
import { ToastContext } from "./ToastContextProvider";
export var useToast = function useToast() {
  var context = useContext(ToastContext);

  if (!context) {
    throw new Error("useToast must be used within a ToastContextProvider");
  }

  return {
    add: context.add,
    remove: context.remove
  };
};